import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '../Layout';

export default class Tree extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentLevel: 0
        };
        this.setCurrentLevel = this.setCurrentLevel.bind(this);
    }

    setCurrentLevel(level) {
        this.setState({
            currentLevel: level
        });
    }

    render() {
        let index = 0;
        const items = React.Children.map(this.props.children, child => {
            index += 1;
            return React.cloneElement(child, {
                level: index,
                setCurrentLevel: this.setCurrentLevel,
                currentLevel: this.state.currentLevel
            });
        });

        return <Flex margin="0px">{items}</Flex>;
    }
}

Tree.propTypes = {
    children: PropTypes.node.isRequired
};
